import { captureException } from "@sentry/react-router"
import { isFirstAttemptForPathname } from "source/shared/isFirstAttemptForPathname"

// See: https://vite.dev/guide/build.html#load-error-handling
export function registerVitePreloadErrorListener() {
  if (typeof window === "undefined") return

  window.addEventListener("vite:preloadError", (event) => {
    // Prevent error being thrown to reduce Sentry noise
    event.preventDefault()

    // reload and warn the first time, then report to Sentry the second
    if (
      isFirstAttemptForPathname("vite-preload-retry", window.location.pathname)
    ) {
      console.warn("vite:preloadError, reloading:", event.payload.message)
      window.location.reload()
      return
    }

    captureException(
      new Error(
        `vite:preloadError persisted after reload: ${event.payload.message}`,
      ),
    )
  })
}
